import { render, staticRenderFns } from "./LED.vue?vue&type=template&id=dd25cc38&scoped=true&"
import script from "./LED.vue?vue&type=script&lang=js&"
export * from "./LED.vue?vue&type=script&lang=js&"
import style0 from "./LED.vue?vue&type=style&index=0&id=dd25cc38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd25cc38",
  null
  
)

export default component.exports